function App() {
  return (
    <div style={{
      fontFamily: "Arial, sans-serif",
      textAlign: "center",
      padding: "50px",
      backgroundColor: "#f4f4f4",
      color: "#333",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }}>
      <h1 style={{ fontSize: "28px", marginBottom: "10px" }}>idVego</h1>
      <h2 style={{ fontSize: "18px", fontWeight: "normal", marginBottom: "20px" }}>
        Scientific Advising & Consulting
      </h2>
      <p style={{ maxWidth: "600px", fontSize: "16px", lineHeight: "1.5", marginBottom: "20px" }}>
        Led by Dr. Chloe Taub, PhD, a distinguished clinical health psychology researcher specializing in oncology and digital health. Dr. Taub has made significant contributions to understanding the interplay between psychological factors and health outcomes in cancer patients. Her research encompasses cognitive behavioral stress management and the impact of stress on inflammatory processes.
      </p>
      <p style={{ maxWidth: "600px", fontSize: "16px", lineHeight: "1.5" }}>
        At idVego, we are committed to advancing clinical innovation, digital health, behavioral science, and the promotion of mental and physical well-being.
      </p>
    </div>
  );
}

export default App;
